export const headers = [
  { field: "razon_social", headerName: "Razon Social", width: 200 },
  { field: "cli_name", headerName: "Nombre Fantasia", width: 200 },

  { field: "fecha", headerName: "Fecha", width: 105 },

  { field: "hora", headerName: "Hora", width: 60 },
  { field: "direccion", headerName: "Dirección", width: 200 },
  { field: "estado_pedido", headerName: "Pedido?", width: 80 },
  {
    field: "distancia_metros",
    headerName: "Distancia",
    width: 80,
    renderCell: (params) =>
      params.row.distancia_metros
        ? `${params.row.distancia_metros}`
        : "—",
  },
  { field: "sel_name", headerName: "Preventista", width: 160 },
];

export const headersImpresion = [
  { field: "cli_name", headerName: "Cliente", width: 160 },
  { field: "fecha", headerName: "Fecha", width: 75 },
  { field: "direccion", headerName: "Dirección", width: 200 },
  { field: "estado_pedido", headerName: "Pedido?", width: 45 },
  {
    field: "distancia_metros",
    headerName: "Distancia",
    width: 50,
    renderCell: (params) =>
      params.row.distancia_metros
        ? `${params.row.distancia_metros}`
        : "—",
  },
  { field: "sel_name", headerName: "Preventista", width: 100 },
];
